import React from 'react';
import { gql } from '@apollo/client';
import { Breakpoint } from '@moda/om';
import { ProductMediaGalleryFragment } from '../../generated/types';
import {
  DesktopProductMediaGallery,
  DESKTOP_PRODUCT_MEDIA_GALLERY_FRAGMENT
} from './DesktopProductMediaGallery';
import {
  MobileProductMediaGallery,
  MOBILE_PRODUCT_MEDIA_GALLERY_FRAGMENT
} from './MobileProductMediaGallery';

export const PRODUCT_MEDIA_GALLERY_FRAGMENT = gql`
  fragment ProductMediaGalleryFragment on Variant {
    ...DesktopProductMediaGalleryFragment
    ...MobileProductMediaGalleryFragment
  }
  ${DESKTOP_PRODUCT_MEDIA_GALLERY_FRAGMENT}
  ${MOBILE_PRODUCT_MEDIA_GALLERY_FRAGMENT}
`;

interface Props {
  variant: ProductMediaGalleryFragment;
}

export const ProductMediaGallery: React.FC<Props> = ({ variant }) => (
  <>
    <Breakpoint gt="sm">
      <DesktopProductMediaGallery variant={variant} />
    </Breakpoint>

    <Breakpoint lt="sm">
      <MobileProductMediaGallery variant={variant} />
    </Breakpoint>
  </>
);
